import { useEffect } from "react";
import "./App.css";
import "./styles/custom.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Impact from "./components/Impact";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CaseStudyInvoice from "./components/CaseStudyInvoice";
import CaseStudyHR from "./components/CaseStudyHR";
import CaseStudyTraining from "./components/CaseStudyTraining";
import Consulting from "./components/Consulting";
import CaseStudyDomain from "./components/CaseStudyDomain";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Portfolio = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, []);

  return (
    <div className="min-h-screen bg-bg-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Skills />
        <Impact />
        <Experience />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/case-studies/invoice-system" element={<CaseStudyInvoice />} />
          <Route path="/case-studies/hr-platform" element={<CaseStudyHR />} />
          <Route path="/case-studies/training-platform" element={<CaseStudyTraining />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/case-studies/domain-watcher" element={<CaseStudyDomain />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
